import { useEffect, useState } from 'react';
import { Page, Card, Text, BlockStack, Button, Checkbox, TextField, InlineStack, Badge, Banner } from '@shopify/polaris';
import TrafficArmorSettings from '../componens/trafficArmorSettings';
import { TRAFFICARMOR_TYPE_GROUPS, TrafficArmorTypeRule } from '../components/TrafficArmorTypeRules';
import { SecretField, SettingsFeedback, SettingsLoading } from '../components/SettingsFields';
import { settingsRequest, settingsError } from '../api/adminSettings';

function CodTrafficArmor() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);
  const load = async () => { setError(''); try { setData(await settingsRequest('g-cod-trafficarmor')); } catch (e) { setError(settingsError(e)); } };
  useEffect(() => { load(); }, []);
  const update = key => value => { setData(prev => ({ ...prev, [key]: value })); setSuccess(''); };
  const changeTypes = (codes, blocked) => {
    const types = new Set(data.trafficarmor_blocked_isp_types);
    codes.forEach(code => blocked ? types.add(code) : types.delete(code));
    update('trafficarmor_blocked_isp_types')([...types].sort());
  };
  const save = async () => {
    setSaving(true); setError(''); setSuccess('');
    try {
      const { trafficarmor_enabled, trafficarmor_campaign_id, trafficarmor_campaign_key, trafficarmor_blocked_isp_types } = data;
      setData(await settingsRequest('u-cod-trafficarmor', { trafficarmor_enabled, trafficarmor_campaign_id, trafficarmor_campaign_key, trafficarmor_blocked_isp_types }));
      setSuccess('COD settings saved.');
    } catch (e) { setError(settingsError(e)); }
    finally { setSaving(false); }
  };
  return <Card><BlockStack gap="300"><InlineStack gap="300" blockAlign="center"><Text as="h2" variant="headingMd">COD</Text>
    {data && <Badge>{data.trafficarmor_enabled ? 'Enabled' : 'Disabled'}</Badge>}</InlineStack>
    <SettingsFeedback error={error} success={success} retry={!data ? load : undefined} />
    {!data ? (!error && <SettingsLoading />) : <>
      <Checkbox label="Enable TrafficArmor for COD" checked={data.trafficarmor_enabled} onChange={update('trafficarmor_enabled')} disabled={saving} />
      <TextField label="Campaign ID" value={data.trafficarmor_campaign_id} onChange={update('trafficarmor_campaign_id')} autoComplete="off" helpText="6 letters or numbers" disabled={saving} />
      <SecretField label="Replace campaign key" value={data.trafficarmor_campaign_key || ''} onChange={update('trafficarmor_campaign_key')} disabled={saving}
        helpText={data.trafficarmor_campaign_key_configured ? 'A key is saved. Leave blank to keep it.' : '32 hexadecimal characters. Required when enabled.'} />
      <Text as="h3" variant="headingSm">Blocked ISP types</Text>
      {TRAFFICARMOR_TYPE_GROUPS.map(group => {
        const options = (data.trafficarmor_isp_type_options || []).filter(option => (option.group || 'observed') === group.key);
        return options.length ? <details key={group.key} open={group.key === 'recommended'}><summary>{group.title}</summary><BlockStack gap="200">
          <Text as="p" tone="subdued">{group.description}</Text>{options.map(option => <TrafficArmorTypeRule key={option.code} option={option} blockedTypes={data.trafficarmor_blocked_isp_types} loading={saving} onChange={changeTypes} />)}
        </BlockStack></details> : null;
      })}
      <InlineStack align="end"><Button variant="primary" loading={saving} onClick={save}>Save COD settings</Button></InlineStack>
    </>}
  </BlockStack></Card>;
}

export default function TrafficProtection() {
  return <Page>
    <div className="settings-stack">
      <InlineStack><Text as="p" tone="subdued">TrafficArmor checks for online checkout and COD.</Text></InlineStack>
      <div className="settings-grid"><div><TrafficArmorSettings /></div><div><CodTrafficArmor /></div></div>
      <Banner>Existing COD phone/IP limits, allowlists and blacklists stay in COD → Risk management.</Banner>
    </div>
  </Page>;
}
